"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reports = void 0;
exports.reports = {
    turnover: {
        method: 'get',
        path: '/reports/turnover',
        response: {},
    },
    hotelTurnover: {
        method: 'get',
        path: '/reports/hotel-turnover',
        response: {},
    },
    companyTurnover: {
        method: 'get',
        path: '/reports/company-turnover',
        response: {},
    },
    forecast: {
        method: 'get',
        path: '/reports/forecast',
        response: {},
    },
    cancellation: {
        method: 'get',
        path: '/reports/cancellation',
        response: {},
    },
    hotelSales: {
        method: 'get',
        path: '/reports/hotel-sales',
        response: {},
    },
};
//# sourceMappingURL=reports.api.js.map